
import { IUser } from "@/api/types/user";
import { patchUserByTypeV3 } from "@/api/user";
import BaseInput from "@/components-UI/BaseInput.vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import BaseCard from "@/components/base/BaseCard.vue";
import Status from "@/components/base/Status.vue";
import BaseSelect from "@/components/base/design/BaseSelect.vue";
import { eventBus } from "@/eventbus";
import { MESSENGER } from '@/mappings/messengers';
import { showServerError } from "@/utils";
import { translateBoolean, translateTwoFactor } from "@/utils/translate";
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const auth = namespace('authModule');

@Component({
    methods: { translateTwoFactor, translateBoolean },
    components: {
        BaseCard,
        BaseSelect,
        Status,
        BaseList,
        BaseListItem,
        BaseInput,
    },
})
export default class UserCardMessengers extends Vue {
    @Prop({ required: true }) user!: IUser;
    @PropSync('isLoading') isLoadingSync!: boolean;
    @auth.Getter('GET_USER') currentUser;
    MESSENGER = MESSENGER;
    isEdit = false;
    userData: any = {
        teams: '',
        telegram: '',
        whatsapp: '',
        wechat: '',
    };

    get getOptions(): any[] {
        return [
            {
                name: 'Teams',
                value: this.userData.teams,
                type: MESSENGER.TEAMS,
                updateUserData: (newValue) => this.userData.teams = newValue,
                hasError: this.userData.teams ? !this.isValidEmail(this.userData.teams) : false,
            },
            {
                name: 'Telegram',
                value: this.userData.telegram,
                type: MESSENGER.TELEGRAM,
                updateUserData: (newValue) => this.userData.telegram = newValue,
            },
            {
                name: 'WhatsApp',
                value: this.userData.whatsapp,
                type: MESSENGER.WHATSAPP,
                updateUserData: (newValue) => this.userData.whatsapp = newValue,
            },
            {
                name: 'WeChat',
                value: this.userData.wechat,
                type: MESSENGER.WECHAT,
                updateUserData: (newValue) => this.userData.wechat = newValue,
            },
        ];
    }

    get hasValidationErrors(): boolean {
        return this.getOptions.some(item => item.hasError);
    }

    isValidEmail(value: string): boolean {
        return /^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/.test(value);
    }

    getMessengerAccount(type: string): string {
        const messenger = this.user.messengers?.find((item) => item.type === type);
        return messenger ? messenger.account : '';
    }

    editInfo(edit: boolean): void {
        if (edit) {
            this.setDefaults();
        } else {
            this.updateAllUserData();
        }
        this.isEdit = edit;
    }

    cancelEdit(): void {
        this.isEdit = false;
    }

    setDefaults(): void {
        this.userData.telegram = this.getMessengerAccount(MESSENGER.TELEGRAM);
        this.userData.whatsapp = this.getMessengerAccount(MESSENGER.WHATSAPP);
        this.userData.teams = this.getMessengerAccount(MESSENGER.TEAMS);
        this.userData.wechat = this.getMessengerAccount(MESSENGER.WECHAT);
    }

    created(): void {
        this.setDefaults();
    }

    async updateUser(): Promise<void> {
        const accountId = this.user.id as number;
        try {
            this.user.messengers = [
                { type: MESSENGER.TELEGRAM, account: this.userData.telegram },
                { type: MESSENGER.WHATSAPP, account: this.userData.whatsapp },
                { type: MESSENGER.TEAMS, account: this.userData.teams },
                { type: MESSENGER.WECHAT, account: this.userData.wechat },
            ];
            const messengers = this.user.messengers.filter(i => i.account);
            await patchUserByTypeV3(accountId, this.user.account_type!,
                { messengers });
        } catch (err) {
            showServerError(err, 'Ошибка сохранения');
        }
    }

    async updateAllUserData(): Promise<void> {
        this.isLoadingSync = true;
        await this.updateUser();
        eventBus.$emit("update-user");
        this.isLoadingSync = false;
    }
}
